"use client";

import useTranslations from "@/i18n/useTranslations";

function HowToApply({ title }: { title: string }) {
  const t = useTranslations("DegreeTY");

  return (
    <div className="w-full">
      <h2 className="text-3xl font-bold text-primary-500 mt-0 mb-6">
        {title || t("howToApply")}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 bg-putty-200 border border-putty-400 rounded-xl p-5">
        <div className="flex flex-col gap-2">
          <div className="flex">
            <h4 className="text-primary-500 text-xl font-semibold my-0">
              {t("step1Title")}
            </h4>
          </div>
          <p className="text-primary-500 mb-0">{t("step1Body")}</p>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex">
            <h4 className="text-primary-500 text-xl font-semibold my-0">
              {t("step2Title")}
            </h4>
          </div>
          <p className="text-primary-500 mb-0">{t("step2Body")}</p>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex">
            <h4 className="text-primary-500 text-xl font-semibold my-0">
              {t("step3Title")}
            </h4>
          </div>
          <p className="text-primary-500 mb-0">{t("step3Body")}</p>
        </div>

        <div className="flex flex-col gap-2">
          <div className="flex">
            <h4 className="text-primary-500 text-xl font-semibold my-0">
              {t("step4Title")}
            </h4>
          </div>
          <p className="text-primary-500 mb-0">{t("step4Body")}</p>
        </div>
      </div>
    </div>
  );
}

export default HowToApply;
